<template>
  <div class="Authentication">
    <h1>Log in</h1>

    <social-account-auth-buttons
      import-comment="Website Regular Signup"
      auth-type="login"
    />

    <div class="Authentication-divider">
      <span class="Authentication-text">
        OR
      </span>
    </div>

    <p>Enter your login details</p>

    <login-form
      @login-form:success="logLoginSuccess"
      @login-form:error="logLoginFailure"
    />

    <a
      href="/register"
      class="RegisterLink"
    >Not signed up yet? Create a FREE account here.</a>
  </div>
</template>

<script>
import SocialAccountAuthButtons from '@/components/authentication/common/social-account-auth-buttons';
import LoginForm from '@/components/authentication/forms/login-form';

export default {
  components: {
    SocialAccountAuthButtons,
    LoginForm,
  },
  props: {
    noRedirect: {
      default: false,
      type: Boolean,
    },
  },

  beforeMount() {
    if (this.isLoggedIn && !this.noRedirect) {
      window.location.href = '/dashboard';
    }
  },

  methods: {
    logLoginSuccess({ redirectUrl = null }) {
      this.$gtag.send({
        event: 'login',
        action: 'login-page-success',
      });

      if (redirectUrl !== null) {
        window.location.href = redirectUrl;
        return;
      }

      if (!this.noRedirect) {
        window.location.href = '/dashboard';
      }
    },
    logLoginFailure() {
      this.$gtag.send({
        event: 'login',
        action: 'login-page-unsuccessful',
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .LoginForm {
    margin-bottom: spacing();
  }

  .RegisterLink {
    display: inline-block;
    margin-top: spacing();
  }
</style>
